import axios from "axios";
import { ref } from "vue";
import { dashboardApiHost } from "@/constants/urls.js";

export async function getProtectedCampaignGiftBonusPointList(campaignId, teamId, params) {
  const url = `${dashboardApiHost}/orgarea/api/v1/donor_account/logins_to_teams/team/${teamId}/campaign/${campaignId}/campaign-gift-bonus-point`;
  const { data, headers } = await axios.get(url, { params });

  return {
    data,
    count: Number(headers["x-total-records"] || 0),
  };
}

export function useProtectedCampaignGiftBonusPoint() {
  const items = ref([]);
  const total = ref(0);
  const loading = ref(false);

  async function fetchProtectedCampaignGiftBonusPointList(campaignId, teamId, params) {
    loading.value = true;

    try {
      const { data, count } = await getProtectedCampaignGiftBonusPointList(
        campaignId,
        teamId,
        params
      );
      items.value = Array.isArray(data) ? data : [];
      total.value = count;
    } catch (e) {
      console.error(e);
      throw e;
    } finally {
      loading.value = false;
    }
  }

  return {
    items,
    total,
    loading,
    fetchProtectedCampaignGiftBonusPointList,
  };
}
